export default __webpack_public_path__ + "static/media/hero-payroll-phone.c6ee605f.jpg";